import type { Product } from "@jti/magento";

export const getCartItemsCount = (items: Partial<Product>[]): number => {
  if (!Array.isArray(items)) {
    return 0;
  }

  return items.reduce((count, { quantity }) => count + (quantity || 0), 0);
};
